<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import type { DataRow } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
  import { mdiArchiveOutline, mdiArchiveArrowUpOutline } from "@mdi/js"
  import type { AddressRow } from "../../_shared/_logic/address-table-contract"
  import {
    CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS,
    customerRegistryActionTooltips,
  } from "../../../../../../_shared/_logic/customer-registry-action-tooltips"

  let {
    selectedRows = [],
    clearSelection,
    batchMutating = false,
    importLocked = false,
    lockedTooltip,
    onMutateSelected,
  }: {
    selectedRows?: DataRow[]
    clearSelection: () => void
    batchMutating?: boolean
    importLocked?: boolean
    lockedTooltip: string
    onMutateSelected: (rows: DataRow[], clearSelection: () => void) => void | Promise<void>
  } = $props()

  const archivedCount = $derived(
    selectedRows.filter((row) => Boolean((row as AddressRow).property?.archived_at)).length,
  )
  const mixed = $derived(archivedCount > 0 && archivedCount < selectedRows.length)
  const restore = $derived(selectedRows.length > 0 && archivedCount === selectedRows.length)
</script>

<CTA
  type="secondaryButton"
  small={true}
  darkMode={false}
  content={restore ? "Auswahl wiederherstellen" : "Auswahl archivieren"}
  disabled={batchMutating || importLocked || mixed}
  tooltipContent={importLocked
    ? lockedTooltip
    : mixed
      ? "Aktive und archivierte Liegenschaften bitte getrennt auswählen."
      : restore
        ? customerRegistryActionTooltips.propertyBatchRestore
        : customerRegistryActionTooltips.propertyBatchArchive}
  tooltipClassName={CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS}
  onClick={() => onMutateSelected(selectedRows, clearSelection)}
>
  {#snippet iconSnippet()}
    <Icon path={restore ? mdiArchiveArrowUpOutline : mdiArchiveOutline} />
  {/snippet}
</CTA>
